var map = {
	"./EVO.png": 1673,
	"./Path 20295.png": 1674,
	"./ab-img.webp": 1675,
	"./ab-title-cn.webp": 1676,
	"./ab-title-en.webp": 1677,
	"./ag-img.png": 1678,
	"./ag-img.webp": 1679,
	"./ag-title-cn.webp": 1680,
	"./ag-title-en.webp": 1681,
	"./chess-img.webp": 1682,
	"./coin-img.webp": 1683,
	"./content-img.webp": 1684,
	"./dg-img.webp": 1685,
	"./dg-title-cn.webp": 1686,
	"./dg-title-en.webp": 1687,
	"./diamond-img.webp": 1688,
	"./dice-coin.webp": 1689,
	"./ea-img.webp": 1690,
	"./ea-title-cn.webp": 1691,
	"./ea-title-en.webp": 1692,
	"./evo-img.webp": 1693,
	"./evo-title-cn.webp": 1694,
	"./evo-title-en.webp": 1695,
	"./golddice-img.webp": 1696,
	"./gp-img.webp": 1697,
	"./gp-title-cn.webp": 1698,
	"./gp-title-en.webp": 1699,
	"./heart-coin-img.webp": 1700,
	"./lc-bg.webp": 1701,
	"./mg-img.webp": 1702,
	"./mg-title-cn.webp": 1703,
	"./mg-title-en.webp": 1704,
	"./pp-img.webp": 1705,
	"./pp-title-cn.webp": 1706,
	"./pp-title-en.webp": 1707,
	"./pt-img.webp": 1708,
	"./pt-title-cn.webp": 1709,
	"./pt-title-en.webp": 1710,
	"./sa-img.webp": 1711,
	"./sa-title-cn.webp": 1712,
	"./sa-title-en.webp": 1713,
	"./sbo-img.webp": 1714,
	"./sbo-title-cn.webp": 1715,
	"./sbo-title-en.webp": 1716,
	"./spade-img.webp": 1717,
	"./title-cn.webp": 1718,
	"./title-en.webp": 1719,
	"./white-spade-img.webp": 1720
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1672;